import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { filter, firstValueFrom, timeout } from 'rxjs';
import { AppComponent } from '../app.component';

@Injectable({ providedIn: 'root' })
export class EnterpriseGuard {
  constructor(private navCtrl: NavController) {}

  async canActivate(
    _activatedRoute: ActivatedRouteSnapshot,
    _routerState: RouterStateSnapshot
  ): Promise<boolean> {
    if (AppComponent.enterprise.value) {
      return true;
    }
    try {
      await firstValueFrom(
        AppComponent.enterprise.pipe(
          filter((e) => !!e),
          timeout(3000)
        )
      );
      return true;
    } catch {
      this.navCtrl.navigateForward('/select-enterprise');
      return false;
    }
  }
}
